import clsx from 'clsx';
import Markdown from 'components/common/MarkdownV2';
import ResponsiveImage from 'components/common/ResponsiveImage';
import MarkdownWithBullet from 'components/common/MarkdownWithBullet';
import { imageDimension } from 'lib/helper';
import styles from './productItemTwoColumn.module.scss';

interface ProductItemTwoColumnProps {
  titleColor: string;
  title: string;
  subtitleColor: string;
  subtitle: string;
  bulletColor?: string;
  image: any;
  content: string | null;
}

function ProductItemTwoColumn({
  titleColor,
  title,
  subtitleColor,
  subtitle,
  bulletColor,
  image,
  content,
}: Readonly<ProductItemTwoColumnProps>) {
  const dimension =
    image?.desktopImage &&
    imageDimension(image.desktopImage.width, image.desktopImage.height);

  return (
    <div className="flex flex-row flex-wrap h-[auto] w-full">
      {image?.desktopImage && (
        <div
          className={clsx(
            'min-w-full',
            dimension === 'vertical'
              ? 'md:min-w-[5.813rem]'
              : 'md:min-w-[9.4rem]',
            dimension === 'vertical'
              ? 'md:min-h-[9.125rem]'
              : 'md:min-h-[5.813rem]',
            styles.productItemTwoColumn__image
          )}
        >
          <ResponsiveImage
            src={image.desktopImage}
            srcMobile={image.mobileImage}
            artDirection={image.artDirection}
            width={image.desktopImage.width}
            height={image.desktopImage.height}
          />
        </div>
      )}
      <div className="block flex-[0_0_100%] mt-[0.625rem]">
        <div className="text-[16px] leading-[24px] font-bold box overflow-hidden text-ellipsis line-clamp-2">
          <div className="text-left lg:text-center">
            <Markdown md={title} textAlign="center" textColor={titleColor} />
          </div>
        </div>
        <div className="text-[15px] font-normal leading-[22px]">
          <div className="text-left lg:text-center">
            <Markdown
              md={subtitle}
              textAlign="center"
              textColor={subtitleColor}
            />
          </div>
        </div>
      </div>
      <div className="flex-[0_0_100%] mt-[0.625rem]">
        <div className={styles.productItemTwoColumn__text}>
          <MarkdownWithBullet
            bulletColor={bulletColor as string}
            subtitle={content ?? ''}
            align="left"
            subtitleColor={styles.textColor}
            cssClass="heart-bullet-v2"
          />
        </div>
      </div>
    </div>
  );
}

export default ProductItemTwoColumn;
